// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import HaierProduct from './HaierProduct.vue'
import store from '@/store'
/*图片压缩*/
import lrz from 'lrz'

/*vue-resource ajax插件*/
import ajax from 'vue-resource'
Vue.use(ajax)
/*过滤器*/
import { NumFormat,NumFormatInt } from '../../common/filter'
Vue.filter('NumFormat',NumFormat)
Vue.filter('NumFormatInt',NumFormatInt)
//fetch 回溯用
import _fetch from '@/common/fetch'
Vue.use(_fetch)
import '@babel/polyfill';   //IE兼容

if (window.HTMLElement) {
    if (Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1) {
        Object.defineProperty(HTMLElement.prototype, 'dataset', {
            get: function () {
                var attributes = this.attributes; // 获取节点的所有属性
                var name = [];
                var value = []; // 定义两个数组保存属性名和属性值
                var obj = {}; // 定义一个空对象
                for (var i = 0; i < attributes.length; i++) { // 遍历节点的所有属性
                    if (attributes[i].nodeName.slice(0, 5) === 'data-') { // 如果属性名的前面5个字符符合"data-"
                        // 取出属性名的"data-"的后面的字符串放入name数组中
                        name.push(attributes[i].nodeName.slice(5));
                        // 取出对应的属性值放入value数组中
                        value.push(attributes[i].nodeValue);
                    }
                }
                for (var j = 0; j < name.length; j++) { // 遍历name和value数组
                    obj[name[j]] = value[j]; // 将属性名和属性值保存到obj中
                }
                return obj; // 返回对象
            },
        });
    }
}
import "../../assets/bootstrap.css";

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//iview
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);

// import iView from 'iview';
// import 'iview/dist/styles/iview.css';
import "../../assets/index.less";
// Vue.use(iView);
// Vue.use(iView, {
//     transfer: true,
//     size: 'large'
// });

import QzgInput from '../../libs/input/Index'
Vue.component(QzgInput.name,QzgInput);

/*公共方法*/
import common from '@/common'
Vue.use(common)

/*公共方法*/
import haierProductCommon from './common'
Vue.use(haierProductCommon)

// 列宽 $columnW.S (M L XL)
import columnWidth from './common/columnWidth'
Vue.prototype.$columnW=columnWidth;

import axios from '../../common/axios'
Vue.use(axios)

import mixin from '@/mixin/store'

Vue.config.productionTip = true;
Vue.http.options.emulateJSON = true;  //json

new Vue({
    el:'#haierProduct',
    router,
    store,
    mixins:[mixin],
    template: '<HaierProduct/>',
    components: { HaierProduct }
})
// toFixed 方法重写
Number.prototype.toFixed=function (d) { 
	var s=this+""; 
	if(!d)d=0; 
	if(s.indexOf(".")==-1)s+="."; 
	s+=new Array(d+1).join("0"); 
	if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
		var s="0"+RegExp.$2,pm=RegExp.$1,a=RegExp.$3.length,b=true;
		if(a==d+2){
			a=s.match(/\d/g); 
			if(parseInt(a[a.length-1])>4){
				for(var i=a.length-2;i>=0;i--){
					a[i]=parseInt(a[i])+1;
					if(a[i]==10){
						a[i]=0;
						b=i!=1;
					}else break;
				}
			}
			s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");

		}if(b)s=s.substr(1); 
		return (pm+s).replace(/\.$/,"");
	}return this+"";
};


// WEBPACK FOOTER //
// ./src/pages/haierProduct/haierProduct.js